import { makeStyles, Theme } from '@material-ui/core';
export const useTransactionNonStxTokenStyles = makeStyles<Theme>((theme) => ({
  title: {
    fontWeight: 500,
    fontSize: '14px',
    lineHeight: '20px',
    color: '#FFFFFF',
    marginBottom: '0px',
    position: 'relative',
    [theme.breakpoints.down('sm')]: {
      fontSize: '12px',
      marginBottom: '4px',
    },
  },
  wallet: {
    fontSize: '14px',
    fontWeight: 500,
    lineHeight: '20px',
    color: '#ABABAB',
    marginTop: '4px',
  },
  amountTooltip: {
    position: 'absolute',
    width: 'max-content',
    height: 'min-content',
    padding: 5,
    bottom: -30,
    left: '50%',
    transform: 'translateX(-50%)',
    borderRadius: '8px',
    background: '#656569',
    boxShadow: '0px 4px 16px 0px rgba(0, 0, 0, 0.30)',
  },
  linkIcon: {
    marginLeft: '4px',
    display: 'flex',
    '& svg': {
      color: '#ABABAB',
      width: 16,
      height: 17,
      '&:hover': {
        color: '#eeeeee',
      },
    },
  },
}));
